import auth from "../service/auth"
import { createUseFetch } from "./useFetch";

const fetch = auth.getAuthenticatedFetch();

export const useAuthenticatedFetch = createUseFetch(fetch);